import React from 'react';
import Layout from '../components/Layout';
import ScrollReveal from '../components/ScrollReveal';
import { sketchbookImages } from '../data/mockData';
import { resolveImageSrc } from '../utils/cloudinary';

const SKETCHBOOK_IMAGE_WIDTH = 900;
const SKETCHBOOK_IMAGE_HEIGHT = 900;

export default function SketchbookPage() {
  return (
    <Layout>
      <div className="flex justify-center w-full">
        <div className="w-full max-w-4xl pb-10 flex flex-col items-center justify-center">
          <ScrollReveal y={18}>
            <h1 className=" text-2xl sm:text-3xl md:text-4xl text-inkwell-900 leading-tight italic border-l-2 border-rose-dusty pl-6 mb-12 sm:mb-16">
              Not every project becomes a full case study! Some moments still deserve the spotlight.
            </h1>
          </ScrollReveal>

          <div className="flex flex-col gap-8 sm:gap-12">
            {sketchbookImages.map((image, i) => (
              <ScrollReveal key={`${image.src}-${i}`} delay={Math.min(i * 70, 280)}>
                <img
                  src={resolveImageSrc(image.src, { maxWidth: SKETCHBOOK_IMAGE_WIDTH, maxHeight: SKETCHBOOK_IMAGE_HEIGHT })}
                  alt={image.alt || `Sketch ${i + 1}`}
                  className="w-full rounded-xl border border-cream-300/60 shadow-sm hover-lift"
                  loading="lazy"
                  style={{ maxWidth: SKETCHBOOK_IMAGE_WIDTH, maxHeight: SKETCHBOOK_IMAGE_HEIGHT }}
                />
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
